import axios from "axios"
import { useEffect, useState } from "react"
import { EMPLOYEES_API } from "../../../../Utilities/APIs"

function DeleteInvite({employee, targetID, setShowDeleteSection, setShowModal, triggerFetch}) {

    const [email, setEmail] = useState('')

    useEffect(() => {

        const config = {
          headers: {
            Authorization: `Bearer ${employee.token}`
          }
        }
    
        async function fetchAndSetEmail() {
          const {data} = await axios.get(EMPLOYEES_API + 'getSingleInvite/' + targetID, config)
          setEmail(data.email)
        }
    
        fetchAndSetEmail()
    
    }, [targetID, employee.token])
    
    async function handleDelete() {

        const config = {
            headers: {
                Authorization: `Bearer ${employee.token}`
            }
        }
        
        const response = await axios.delete(EMPLOYEES_API + 'deleteInvite/' + targetID, config)

        if (response) {
            setEmail('')

            setShowDeleteSection(false)
            setShowModal(false)
            triggerFetch()
        }
    }
    return (
        <div className='modal_delete_content'>
      
            <p>Are you sure you want to delete invite for {email ? email : ''}?</p>

            <div className="modal_group_buttons">
                <button
                className="delete" onClick={() => {
                    handleDelete()
                }}
                >Delete</button>

                <button className="cancel" onClick={() => {
                    setShowModal(false)
                    setShowDeleteSection(false)
                }}>Cancel</button>
            </div>

        </div>
    )
}

export default DeleteInvite